import MediaMixAnalysisReport from "../mediaMixAnalysis";
import MarketingEfficiencyIndexReport from "../marketingEfficiencyIndex";
import ChannelBenchmarksReport from "../channelBenchmarks";
const beckMarkReportRoute = [
  {
    path: "benchmarking-report/:pId/channel-benchmarks",
    element: <ChannelBenchmarksReport />,
  },
  {
    path: "benchmarking-report/:pId/media-mix-analysis",
    element: <MediaMixAnalysisReport />,
  },
  {
    path: "benchmarking-report/:pId/marketing-efficiency-index",
    element: <MarketingEfficiencyIndexReport />,
  },
];
export default beckMarkReportRoute;
